import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import ActivityFeed from '../components/dashboard/ActivityFeed';
import ConnectButton from '../components/common/ConnectButton';
import Loader from '../components/common/Loader';

const Activity = () => {
  const { connected } = useWallet();
  const { userId, initialLoading, isRegistered } = useUserData();

  if (!connected) {
    return (
      <div className="main-content">
        <div className="connect-prompt">
          <div className="connect-prompt-icon">🔗</div>
          <h2>Connect Your Wallet</h2>
          <div className="mt-lg"><ConnectButton /></div>
        </div>
      </div>
    );
  }

  if (initialLoading) return <Loader text="Loading Activity" />;
  if (!isRegistered) return <Navigate to="/register" replace />;

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">Activity Log</h1>
        <p className="page-subtitle">Your last 100 activities on-chain</p>
      </div>

      <ActivityFeed userId={userId} limit={100} />
    </div>
  );
};

export default Activity;
